'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'border-all';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f84c';
var svgPathData = ['M16 96l0 144 192 0 0-192-144 0C37.5 48 16 69.5 16 96zm0 160l0 160c0 26.5 21.5 48 48 48l144 0 0-208-192 0zM224 48l0 192 208 0 0-144c0-26.5-21.5-48-48-48L224 48zm0 208l0 208 160 0c26.5 0 48-21.5 48-48l0-160-208 0z', 'M384 48c26.5 0 48 21.5 48 48l0 144-208 0 0-192 160 0zm48 208l0 160c0 26.5-21.5 48-48 48l-160 0 0-208 208 0zM208 240L16 240 16 96c0-26.5 21.5-48 48-48l144 0 0 192zM16 256l192 0 0 208-144 0c-26.5 0-48-21.5-48-48l0-160zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBorderAll = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;